<template><!-- gotop 至頂功能 -->
    <div
        class="goTop iconfont ml-gotop"
        :class="isTop ? 'goTopAfter' : ''"
        @click="goTop()"
    ></div>
</template>
<script setup>
        import $ from "jquery";
import {onBeforeMount, ref} from "vue";

        const isTop = ref(false)
        const goTop = () => {
            $('html,body').stop().animate({
                scrollTop: 0
            }, 'slow', 'swing');
        }
        onBeforeMount(()=>{
            window.addEventListener("scroll", () => {
                let top =
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    window.pageYOffset;
                if (top >= 100) {
                    isTop.value = true;
                } else {
                    isTop.value = false;
                }
            });
        })

</script>
<style lang="scss">
.goTop {
    position: fixed;
    bottom: -100px;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius:10px;
    text-align: center;
    z-index: 100;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    background: rgba(0,0,0,0.3);
    &::after{
        content:"";
        display:inline-block;
        background-image: url("../assets/arrow-top.svg");
        background-position: center;
        background-repeat: no-repeat;
        width:32px;
        height:32px;
        margin-top:5px;
        opacity:0.7;
    }
    &:hover{
        background: rgba(0,0,0,0.5);
        transition: 0.3s ease-in-out;
    }
}
.goTopAfter {
    transition: 0.3s ease-in-out;
    bottom: 140px;
}
</style>
